import {Injectable} from '@angular/core';
import {AbstractModelService} from '../model/abstract-model.service';
import {ApiClientService} from '../api-client/api-client.service';
import {PartnerCappingRule} from '../../models/partner/partner-capping-rule';

@Injectable({
  providedIn: 'root'
})
export class PartnerCappingRuleService extends AbstractModelService<PartnerCappingRule> {
  constructor(apiClient: ApiClientService) {
    super(apiClient, '/partner-capping-rule', PartnerCappingRule);
  }
}
